<div class="page-loader" *ngIf="isSubmitting">
  <mat-spinner diameter="60"></mat-spinner>
  <div class="loader-text">Submitting, please wait...</div>
</div>
<mat-drawer-container class="drawer-container" autosize>


  <mat-drawer-content class="drawer-content">
    <div class="container-fluid page-shell">
      <div class="text-right">
        <button class="btn btn-light hover-button mail" (click)="clearClick()">
          <mat-icon>clear_all</mat-icon> &nbsp;Clear
        </button>
        <button class="btn btn-light hover-button mail" (click)="submitClick()" [disabled]="alreadySubmitted">
          <mat-icon>done</mat-icon> Submit
        </button>
        <button class="btn btn-light hover-button mail" (click)="verifyReport()">
          <mat-icon>visibility</mat-icon>
          Approve
        </button>
        <!-- <button class="btn btn-light hover-button mail w-auto btn-draft-error-mail"
          (click)="draftErrorEmail()"
          [disabled]="!errorAvailable || isSubmitting || isDraftingEmail"
          [title]="errorMailDrafted ? ('Email already drafted at ' + (errorMailDraftedAt | date:'MMM d, HH:mm')) : 'Draft and send error notification email'">
          <mat-icon>{{ isDraftingEmail ? 'hourglass_top' : 'mark_email_unread' }}</mat-icon>
          {{ isDraftingEmail ? 'Capturing & Drafting...' : (errorMailDrafted ? 'Re-draft Error Mail' : 'Draft Error Mail') }}
        </button> -->
        <button *ngIf="canDraftEmail" class="btn btn-light hover-button mail w-auto btn-view-draft-email" (click)="viewDraftEmail()"
          [disabled]="!errorAvailable || isSubmitting || isDraftingEmail || isLoadingDraftPreview"
          title="Preview the exact email template with To and CC fields as it will be sent">
          <mat-icon>{{ isLoadingDraftPreview ? 'hourglass_top' : 'drafts' }}</mat-icon>
          {{ isLoadingDraftPreview ? 'Preparing Preview...' : 'Draft Email' }}
        </button>
        <button *ngIf="canDraftEmail && isPortMailEvent" class="btn btn-light hover-button mail w-auto"
          (click)="openPortMail()" [disabled]="isLoadingPortMail"
          title="Draft the port call / cargo documents email to the Master (EmzOil and Elite tankers)">
          <mat-icon>{{ isLoadingPortMail ? 'hourglass_top' : 'local_shipping' }}</mat-icon>
          Port Mail
        </button>
        <button class="btn btn-light hover-button mail w-auto" (click)="openForceApproveModal()"
          [disabled]="!canForceApprove || isSubmitting">
          <mat-icon>gavel</mat-icon>
          Force Ingest
        </button>
        <button class="btn btn-light hover-button mail w-auto" (click)="downloadErrorExcel()"
          [disabled]="!errorAvailable">
          <mat-icon>report_problem</mat-icon>
          Download Error
        </button>
        <!-- <button class="btn btn-light hover-button mail" (click)="openRetrievePopup()">
          <mat-icon>restore</mat-icon>
          Retrieve
        </button> -->
        <button class="btn btn-light hover-button mail" (click)="goToDashboardReporting()">
          <mat-icon>dashboard</mat-icon>
          Reports
        </button>

        <!-- <button class="btn btn-light hover-button mail" (click)="downloadExcel()">
  <mat-icon>download</mat-icon> Excel
</button> -->

        <button class="btn btn-light hover-button mail" (click)="backToRequestForm()">
          <mat-icon>arrow_back</mat-icon> Back
        </button>
      </div>
      <div *ngIf="errorMailDrafted"
        class="error-mail-audit-banner alert alert-info d-flex align-items-center justify-content-between mb-3"
        style="border-radius: 6px; padding: 10px 16px; margin: 10px 0;">
        <div>
          <mat-icon style="vertical-align: middle; margin-right: 6px; color: #0284c7;">check_circle</mat-icon>
          <strong>Error Notification Email Drafted:</strong> An error summary email was drafted and sent to
          <code>reports@merakishippingservices.com</code> on {{ errorMailDraftedAt | date:'medium' }}.
        </div>
        <span class="badge bg-primary" style="font-size: 12px; padding: 5px 10px;">Audited</span>
      </div>
      <div class="bgv">
        <form [formGroup]="requestForm" class="master-form">
          <div class="row fevenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
            <div class="col-md-4">
              <label><span class="asterik-color">*</span>Ship:</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-3">
                  <label class="TextLabel"><span class="asterik-color">*</span> Ship Name</label>
                  <input type="text" class="form-control" formControlName="vesselName" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('vesselName')?.hasError('required'),
                }" />
                  <small class="error" *ngIf="
                  formSubmitted &&
                  requestForm.get('vesselName')?.hasError('required')
                ">
                    Ship Name is required
                  </small>
                </div>

                <div class="col-md-3">
                  <label class="TextLabel"><span class="asterik-color">*</span> IMO Number</label>
                  <input type="number" class="form-control" formControlName="imoNumber" min="0" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('imoNumber')?.hasError('required'),
                }" />
                  <small class="error" *ngIf="
                  formSubmitted &&
                  requestForm.get('imoNumber')?.hasError('required')
                ">
                    IMO Number is required
                  </small>
                </div>

                <div class="col-md-3">
                  <label class="TextLabel"><span class="asterik-color">*</span> Type of Ship</label>
                  <select class="form-control" formControlName="vesselType" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('vesselType')?.hasError('required'),
                }">
                    <option value="" disabled>Select</option>
                    <option *ngFor="let opt of vesselTypeOptions" [value]="opt.value">
                      {{ opt.label }}
                    </option>
                  </select>
                  <small class="error" *ngIf="
                  formSubmitted &&
                  requestForm.get('vesselType')?.hasError('required')
                ">
                    Type of ship is required
                  </small>
                </div>
                <div class="col-md-3">
                  <label class="TextLabel">
                    <span class="asterik-color">*</span> Report Type
                  </label>

                  <select class="form-control" formControlName="reportType" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('reportType')?.hasError('required'),
                }">
                    <option value="" disabled>Select</option>

                    <option *ngFor="let opt of reportTypeOptions" [value]="opt.value">
                      {{ opt.label }}
                    </option>
                  </select>

                  <small class="error" *ngIf="
                  formSubmitted &&
                  requestForm.get('reportType')?.hasError('required')
                ">
                    Report type is required
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
            <div class="col-md-4">
              <label><span class="asterik-color">*</span>Voyage:</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Vessel Segment</label>
                  <select class="form-control" formControlName="vesselSegment" [ngClass]="{
                    'error-border':
                      formSubmitted &&
                      requestForm.get('vesselSegment')?.hasError('required')
                  }">
                    <option value="" disabled>Select</option>
                    <option *ngFor="let opt of segmentOptions" [value]="opt.value">
                      {{ opt.label }}
                    </option>
                  </select>
                  <small class="error" *ngIf="
                    formSubmitted &&
                    requestForm.get('vesselSegment')?.hasError('required')
                  ">
                    Vessel Segment is required
                  </small>
                </div>

                <div class="col-md-2">
                  <label class="TextLabel"><span class="asterik-color">*</span> Condition</label>
                  <select class="form-control" formControlName="vesselCondition" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('vesselCondition')?.hasError('required'),
                }">
                    <option value="" disabled>Select</option>
                    <option value="Ballast">Ballast</option>
                    <option value="Laden">Laden</option>
                  </select>
                  <small class="error" *ngIf="
                  formSubmitted &&
                  requestForm.get('vesselCondition')?.hasError('required')
                ">
                    Condition is required
                  </small>
                </div>

                <div class="col-md-2">
                  <label class="TextLabel">Voyage Number</label>
                  <input type="text" class="form-control" formControlName="voyageNumber" />
                </div>
                <div class="col-md-4">
                  <label class="TextLabel">Meraki Voyage Number</label>
                  <input type="text" class="form-control" formControlName="merakiVoyageNumber" />


                  <div class="form-check mt-2">
                    <input type="checkbox" class="form-check-input" id="endOfLeg" formControlName="endOfLeg"
                      (change)="openMerakiPopup($event)" />
                    <label class="form-check-label" for="endOfLeg">
                      End Of the Leg
                    </label>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
            <div class="col-md-4">
              <label><span class="asterik-color">*</span>Ports:</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-6">
                  <label class="TextLabel"><span class="asterik-color">*</span> From Port</label>
                  <input type="text" class="form-control" formControlName="departurePort" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('departurePort')?.hasError('required'),
                }" />
                  <small class="error" *ngIf="
                  formSubmitted &&
                  requestForm.get('departurePort')?.hasError('required')
                ">
                    From Port is required
                  </small>

                  <!-- Port Suggestions -->
                  <div class="port-suggestion-alert" *ngIf="portSuggestions?.departurePort">
                    <ng-container *ngIf="portSuggestions.departurePort.type === 'typo'">
                      <div class="suggestion-content">
                        <mat-icon class="suggestion-icon">info</mat-icon>
                        <span class="suggestion-text">Did you mean
                          <strong>{{portSuggestions.departurePort.suggested}}</strong>?
                          ({{(portSuggestions.departurePort.confidence * 100).toFixed(0)}}% match)</span>
                      </div>
                      <div class="suggestion-actions">
                        <button type="button" class="btn-apply"
                          (click)="applySuggestion('departurePort', portSuggestions.departurePort.suggested)">Apply</button>
                        <button type="button" class="btn-ignore"
                          (click)="ignoreSuggestion('departurePort')">Ignore</button>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="portSuggestions.departurePort.type === 'new'">
                      <div class="suggestion-content">
                        <mat-icon class="suggestion-icon warning">new_releases</mat-icon>
                        <span class="suggestion-text">"{{portSuggestions.departurePort.original}}" is new. Add to
                          master?</span>
                      </div>
                      <div class="suggestion-actions">
                        <button type="button" class="btn-add" (click)="addNewPortToMaster('departurePort')">Add to
                          Master</button>
                        <button type="button" class="btn-ignore" (click)="ignoreSuggestion('departurePort')">Keep as
                          is</button>
                      </div>
                    </ng-container>
                  </div>
                </div>

                <div class="col-md-6">
                  <label class="TextLabel"><span class="asterik-color"></span> To Port</label>
                  <input type="text" class="form-control" formControlName="destinationPort" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('destinationPort')?.hasError('required'),
                }" />
                  <small class="error" *ngIf="
                  formSubmitted &&
                  requestForm.get('destinationPort')?.hasError('required')
                ">
                    To Port is required
                  </small>

                  <!-- Port Suggestions -->
                  <div class="port-suggestion-alert" *ngIf="portSuggestions?.destinationPort">
                    <ng-container *ngIf="portSuggestions.destinationPort.type === 'typo'">
                      <div class="suggestion-content">
                        <mat-icon class="suggestion-icon">info</mat-icon>
                        <span class="suggestion-text">Did you mean
                          <strong>{{portSuggestions.destinationPort.suggested}}</strong>?
                          ({{(portSuggestions.destinationPort.confidence * 100).toFixed(0)}}% match)</span>
                      </div>
                      <div class="suggestion-actions">
                        <button type="button" class="btn-apply"
                          (click)="applySuggestion('destinationPort', portSuggestions.destinationPort.suggested)">Apply</button>
                        <button type="button" class="btn-ignore"
                          (click)="ignoreSuggestion('destinationPort')">Ignore</button>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="portSuggestions.destinationPort.type === 'new'">
                      <div class="suggestion-content">
                        <mat-icon class="suggestion-icon warning">new_releases</mat-icon>
                        <span class="suggestion-text">"{{portSuggestions.destinationPort.original}}" is new. Add to
                          master?</span>
                      </div>
                      <div class="suggestion-actions">
                        <button type="button" class="btn-add" (click)="addNewPortToMaster('destinationPort')">Add to
                          Master</button>
                        <button type="button" class="btn-ignore" (click)="ignoreSuggestion('destinationPort')">Keep as
                          is</button>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="row lastReported">
                <div class="col-md-6">
                  <label class="TextLabel"> Last Reported From Port</label>
                  <input type="text" class="form-control" [value]="lastReport?.departurePort || ''" disabled />
                </div>
                <div class="col-md-6">
                  <label class="TextLabel"> Last Reported To Port</label>
                  <input type="text" class="form-control" [value]="lastReport?.destinationPort || ''" disabled />
                </div>
              </div>
            </div>
          </div>

          <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
            <div class="col-md-4">
              <label><span class="asterik-color">*</span>Report Time:</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3 align-items-end">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Date</label>
                  <input type="date" class="form-control" formControlName="reportDate" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('reportDate')?.hasError('required'),
                }" />
                  <small class="error" *ngIf="
                  formSubmitted &&
                  requestForm.get('reportDate')?.hasError('required')
                ">
                    Report Date is required
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Time (UTC)</label>
                  <div class="time-picker d-flex gap-2">
                    <input placeholder="HH" type="number" class="form-control time w-50" formControlName="reportHour"
                      min="0" max="23" />
                    <input placeholder="MM" type="number" class="form-control time w-50" formControlName="reportMinute"
                      min="0" max="59" />
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Time Zone</label>
                  <select class="form-control" formControlName="portTimeZone" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('portTimeZone')?.hasError('required'),
                }">
                    <option value="" disabled>Select</option>
                    <option *ngFor="let opt of timezoneOptions" [value]="opt.value">
                      {{ opt.label }}
                    </option>
                  </select>
                  <small class="error" *ngIf="
                  formSubmitted &&
                  requestForm.get('portTimeZone')?.hasError('required')
                ">
                    Time Zone is required
                  </small>
                </div>
              </div>
              <div class="row gy-3 align-items-end lastReported">
                <div class="col-md-4">
                  <label class="TextLabel"> Last Reported Date</label>
                  <input type="text" class="form-control" [value]="
                  (lastReport?.reportDate | date: 'd MMM yyyy HH:mm' : 'UTC') || ''
                " disabled />
                </div>
                <div class="col-md-4">
                  <label class="TextLabel"> Last Reported Time</label>
                  <input type="text" class="form-control" [value]="
                  ((lastReport?.reportHour | number: '2.0-0') || '00') +
                  ':' +
                  ((lastReport?.reportMinute | number: '2.0-0') || '00')
                " disabled />
                </div>
                <div class="col-md-4"></div>
              </div>
            </div>
          </div>

          <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
            <div class="col-md-4">
              <label><span class="asterik-color">*</span>Operations:</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-6">
                  <label class="TextLabel"><span class="asterik-color">*</span> Operations</label>
                  <select class="form-control" formControlName="eventsList" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('eventsList')?.hasError('required'),
                }">
                    <option value="" disabled>Select</option>
                    <option *ngFor="let opt of operationsOptions" [value]="opt.value">
                      {{ opt.label }}
                    </option>
                  </select>
                  <small class="error" *ngIf="
                  formSubmitted &&
                  requestForm.get('eventsList')?.hasError('required')
                ">
                    Operations is required
                  </small>
                </div>

                <div class="col-md-6" *ngIf="isInPort">
                  <label class="TextLabel">Operations in Port</label>
                  <select class="form-control" formControlName="operationInPort">
                    <option value="">Select Operation</option>
                    <option *ngFor="let opt of operationInPortOptions" [value]="opt.value">
                      {{ opt.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="TextLabel"> Last Reported Operation</label>
                  <input type="text" class="form-control" [value]="lastReport?.eventsList || ''" disabled />
                </div>
                <div class="col-md-6"></div>
              </div>
            </div>
          </div>

          <div class="row oddBgv" *ngIf="isAtSea" [ngClass]="{ 'dark-odd': isDarkMode() }">
            <div class="col-md-4">
              <label>ETA:</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3 align-items-end">
                <div class="col-md-4">
                  <label class="TextLabel">ETA C/P Ordered Date</label>
                  <input type="date" class="form-control" formControlName="etaOrderDate" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel">ETA C/P Ordered Time (UTC)</label>
                  <div class="time-picker d-flex gap-2">
                    <input placeholder="HH" type="number" class="form-control w-50 time" formControlName="etaOrderHour"
                      min="0" max="23" />
                    <input placeholder="MM" type="number" class="form-control w-50 time"
                      formControlName="etaOrderMinute" min="0" max="59" />
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="TextLabel">ETA Projected Weather Date</label>
                  <input type="date" class="form-control" formControlName="etaWeatherDate" />
                </div>
              </div>

              <div class="row gy-3 mt-2 align-items-end">
                <div class="col-md-6">
                  <label class="TextLabel">ETA Projected Weather Time (UTC)</label>
                  <div class="time-picker d-flex gap-2">
                    <input placeholder="HH" type="number" class="form-control w-50 time"
                      formControlName="etaWeatherHour" min="0" max="23" />
                    <input placeholder="MM" type="number" class="form-control w-50 time"
                      formControlName="etaWeatherMinute" min="0" max="59" />
                  </div>
                </div>

                <div class="col-md-6">
                  <label class="TextLabel">ETA Projected Weather (LT)</label>
                  <div class="time-picker d-flex gap-2">
                    <input placeholder="HH" type="number" class="form-control w-50 time"
                      formControlName="etaWeatherLthour" min="0" max="23" />
                    <input placeholder="MM" type="number" class="form-control w-50 time"
                      formControlName="etaWeatherLtminute" min="0" max="59" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
            <div class="col-md-4">
              <label>Other Info:</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-4">
                  <label class="TextLabel">Charterer's Name</label>
                  <input type="text" class="form-control" formControlName="chartererName" />
                </div>

                <div class="col-md-4" *ngIf="requestForm.get('vesselType')?.value === 'Refer'">
                  <label class="TextLabel">No. of Reefer Containers</label>
                  <input type="number" class="form-control" formControlName="reeferCount" />
                </div>

                <div class="col-md-4" *ngIf="requestForm.get('vesselType')?.value === 'Refer'">
                  <label class="TextLabel">Reefer kWhr</label>
                  <input type="number" class="form-control" formControlName="reeferKwh" />
                </div>
              </div>
            </div>
          </div>

          <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
            <div class="col-md-4">
              <label><span class="asterik-color">*</span>Draft / Slops:</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Forward Draft</label>
                  <input type="number" class="form-control" formControlName="forwardDraftValue" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('forwardDraftValue')?.hasError('required'),
                }" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> After Draft</label>
                  <input type="number" class="form-control" formControlName="afterDraftValue" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('afterDraftValue')?.hasError('required'),
                }" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Displacement</label>
                  <input type="number" class="form-control" formControlName="displacementValue" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('displacementValue')?.hasError('required'),
                }" />
                </div>
              </div>
            </div>
          </div>

          <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
            <div class="col-md-4"></div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-6">
                  <label class="TextLabel">Slops Volume (M3)</label>
                  <input type="text" class="form-control" formControlName="slopsRob" />
                </div>

                <div class="col-md-6">
                  <label class="TextLabel">Slops location - Slop(p)/ Slop(s)/ ROT</label>
                  <select class="form-control" formControlName="slopsTank">
                    <option value="" disabled>Select</option>
                    <option *ngFor="let opt of slopsTankOptions" [value]="opt.value">
                      {{ opt.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
            <div class="col-md-4">
              <label><span class="asterik-color">*</span>Cargo Information:</label>
            </div>

            <div class="col-md-8 textBox">
              <div formArrayName="cargoDetails">
                <div class="row gy-3 align-items-end mb-2" *ngFor="let cargo of cargoDetails.controls; let i = index"
                  [formGroupName]="i">
                  <div class="col-md-5">
                    <label class="TextLabel">Cargo Name</label>
                    <input type="text" class="form-control" formControlName="name" placeholder="Enter Cargo Name" />
                  </div>

                  <div class="col-md-5">
                    <label class="TextLabel">Quantity (m³)</label>
                    <input type="number" class="form-control" formControlName="quantity" placeholder="0.00" />
                  </div>

                  <div class="col-md-2 d-flex gap-2">
                    <button type="button" class="btn btn-success btn-sm" (click)="addCargoRow()"
                      *ngIf="i === cargoDetails.length - 1">
                      +
                    </button>

                    <button type="button" class="btn btn-danger btn-sm" (click)="removeCargoRow(i)"
                      *ngIf="cargoDetails.length > 1">
                      -
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row fevenBgv align-items-start" [ngClass]="{ 'dark-even': isDarkMode() }">
            <div class="col-md-4">
              <label><span class="asterik-color">*</span>Nautical Log:</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-6">
                  <label class="TextLabel"><span class="asterik-color">*</span> Latitude</label>
                  <div class="rowLatLong">
                    <input type="number" class="form-control" placeholder="Deg (0-90)" formControlName="latitudeDegree"
                      (input)="calculateLatitude()" />
                    <input type="number" class="form-control" placeholder="Min (0-60)" formControlName="latitudeMin"
                      (input)="calculateLatitude()" />
                    <select class="form-control" formControlName="latitudeDir" (change)="calculateLatitude()">
                      <option value="" disabled>Select</option>
                      <option value="N">N</option>
                      <option value="S">S</option>
                    </select>
                  </div>
                  <input type="text" class="form-control mt-2" formControlName="latitudeResult"
                    placeholder="Decimal degree" />
                </div>

                <div class="col-md-6">
                  <label class="TextLabel"><span class="asterik-color">*</span> Longitude</label>
                  <div class="rowLatLong">
                    <input type="number" class="form-control" placeholder="Deg (0-180)"
                      formControlName="longitudeDegree" (input)="calculateLongitude()" />
                    <input type="number" class="form-control" placeholder="Min (0-60)" formControlName="longitudeMin"
                      (input)="calculateLongitude()" />
                    <select class="form-control" formControlName="longitudeDir" (change)="calculateLongitude()">
                      <option value="" disabled>Select</option>
                      <option value="E">E</option>
                      <option value="W">W</option>
                    </select>
                  </div>
                  <input type="text" class="form-control mt-2" formControlName="longitudeResult"
                    placeholder="Decimal degree" />
                </div>
                <!-- VIEW MAP BUTTON -->
                <div class="col-md-12 text-end mt-2">
                  <button type="button" class="btn btn-outline-primary" (click)="toggleMap()"
                    [disabled]="!isLatLongValid()">
                    <i class="fa fa-map-marker"></i>
                    {{ showMap ? "Hide Map" : "View Map" }}
                  </button>
                </div>

                <!-- MAP -->
                <div class="col-md-12 mt-3" *ngIf="showMap">
                  <div class="map-card">
                    <div class="map-header">Location Preview</div>
                    <div id="routeMap" class="leaflet-map"></div>
                  </div>
                </div>
              </div>
              <div class="row lastReported">
                <div class="col-md-6">
                  <label class="TextLabel"> Last Reported Latitude</label>
                  <input type="text" class="form-control" [value]="lastReport?.latitudeResult || ''" disabled />
                </div>
                <div class="col-md-6">
                  <label class="TextLabel"> Last Reported Longitude</label>
                  <input type="text" class="form-control" [value]="lastReport?.longitudeResult || ''" disabled />
                </div>
              </div>
            </div>
          </div>

          <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
            <div class="col-md-4"></div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> C/P Ordered Speed
                    (Knots)</label>
                  <input type="number" class="form-control" formControlName="contractualSpeed" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> C/P Ordered Consumption FO
                    (ME+AE)</label>
                  <input type="number" class="form-control" formControlName="contractualConsumpFo" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> C/P Ordered Consumption GO
                    (AE)</label>
                  <input type="number" class="form-control" formControlName="contractualConsumpGo" />
                </div>
              </div>
            </div>
          </div>

          <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
            <div class="col-md-4"></div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Distance To Go</label>
                  <input type="number" class="form-control" formControlName="remainingDistance" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Steaming Distance
                    (GPS)</label>
                  <input type="number" class="form-control" formControlName="steamingDistanceGps"
                    (input)="calculateAvgSpeed(); calculateSlip()" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Steaming Hours</label>
                  <input type="number" class="form-control" formControlName="steamingHoursReport"
                    (input)="calculateAvgSpeed()" />
                </div>
              </div>
            </div>
          </div>

          <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
            <div class="col-md-4"></div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Average Speed</label>
                  <input type="number" class="form-control disabled-field" formControlName="avgSpeedReport" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Log Distance</label>
                  <input type="number" class="form-control" formControlName="logDistanceReport"
                    (input)="calculateAvgSpeed()" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Log Speed</label>
                  <input type="number" class="form-control disabled-field" formControlName="logSpeedReport" />
                </div>
              </div>
            </div>
          </div>

          <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
            <div class="col-md-4"></div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Avg Ships Course</label>
                  <input type="number" class="form-control" formControlName="avgCourseReport" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Total Distance
                    (GPS)</label>
                  <input type="number" class="form-control" formControlName="totalDistanceGps"
                    (input)="calculateSpeed()" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Total Hours</label>
                  <input type="number" class="form-control" formControlName="totalVoyageHours"
                    (input)="calculateSpeed()" />
                </div>
              </div>
            </div>
          </div>

          <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
            <div class="col-md-4"></div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Overall Avg Speed</label>
                  <input type="number" class="form-control disabled-field" formControlName="overallAverageSpeed" />
                </div>
              </div>
            </div>
          </div>

          <div class="row fevenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
            <div class="col-md-4">
              <label><span class="asterik-color">*</span>Weather:</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> True Wind Direction</label>
                  <input type="number" class="form-control" formControlName="trueWindDirection" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> True Wind (Knots)</label>
                  <input type="number" class="form-control" formControlName="trueWindKnots" min="0" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Wind Force (BF
                    Scale)</label>
                  <input type="number" class="form-control" formControlName="windForceBf" />
                </div>
              </div>

              <div class="row gy-3 mt-2">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Wind Description</label>
                  <select class="form-control" formControlName="windDescriptionSelect">
                    <option value="" disabled>Select</option>
                    <option value="Calm">Calm</option>
                    <option value="Light air">Light air</option>
                    <option value="Light breeze">Light breeze</option>
                    <option value="Gentle breeze">Gentle breeze</option>
                    <option value="Moderate breeze">Moderate breeze</option>
                    <option value="Fresh breeze">Fresh breeze</option>
                    <option value="Strong breeze">Strong breeze</option>
                    <option value="High wind, moderate gale, near gale">
                      High wind, moderate gale, near gale
                    </option>
                    <option value="Gale, fresh gale">Gale, fresh gale</option>
                    <option value="Strong/severe gale">Strong/severe gale</option>
                    <option value="Storm, whole gale">Storm, whole gale</option>
                    <option value="Violent storm">Violent storm</option>
                    <option value="Hurricane force">Hurricane force</option>
                  </select>
                </div>

                <div class="col-md-4">
                  <label class="TextLabel">Relative Wind Speed</label>
                  <input type="number" class="form-control" formControlName="relativeWindSpeedKnots" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel">Relative Wind Direction</label>
                  <input type="number" class="form-control" formControlName="relativeWindDirectionDegrees" />
                </div>
              </div>

              <div class="row gy-3 mt-2">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> True Swell
                    Direction</label>
                  <input type="number" class="form-control" formControlName="swellDirection"
                    (input)="validateDecimal('swellDirection')" />
                  <small class="error" *ngIf="decimalErrors.swellDirection">
                    Only numbers with up to two decimals allowed!
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Swell Height
                    (Meter)</label>
                  <input type="text" class="form-control" formControlName="swellHeightMeter"
                    (input)="validateDecimal('swellHeightMeter')" />
                  <small class="error" *ngIf="decimalErrors.swellHeightMeter">
                    Only numbers with up to two decimals allowed!
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Sea Height (Meter)</label>
                  <input type="text" class="form-control" formControlName="seaHeightMeter"
                    (input)="validateDecimal('seaHeightMeter')" />
                  <small class="error" *ngIf="decimalErrors.seaHeightMeter">
                    Only numbers with up to two decimals allowed!
                  </small>
                </div>
              </div>

              <div class="row gy-3 mt-2">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> True Sea Direction</label>
                  <input type="number" class="form-control" formControlName="trueSeaDirection" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Current Direction</label>
                  <select class="form-control" formControlName="currentDirectionSelect">
                    <option value="" disabled>Select</option>
                    <option value="Against">Against</option>
                    <option value="With">With</option>
                  </select>
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Current (Knots)</label>
                  <input type="number" class="form-control" formControlName="currentKnots" />
                </div>
              </div>

              <div class="row gy-3 mt-2">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Air Temperature
                    (°C)</label>
                  <input type="number" class="form-control" formControlName="airTemperature" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Sea Temperature
                    (°C)</label>
                  <input type="number" class="form-control" formControlName="seaTemperature" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Pressure (mbar)</label>
                  <input type="text" class="form-control" maxlength="4" formControlName="pressureMbar"
                    (input)="validatePressureAngular()" />
                  <small class="error" *ngIf="pressureError">
                    Only 4-digit whole numbers (1000-9999) allowed!
                  </small>
                </div>
              </div>
            </div>
          </div>
          <!-- ===================== ENGINE ROOM LOG ===================== -->
          <!-- <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
            <div class="col-md-4">
              <label><span class="asterik-color">*</span>Engine Room Log:</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Main Engine RPM</label>
                  <input type="number" class="form-control" formControlName="mainEngineRpm" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Engine Avg KW</label>
                  <input type="number" class="form-control" formControlName="engineAverageBhp" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Revolution Counter</label>
                  <input type="number" class="form-control" formControlName="meRevolutionCounter" />
                </div>
              </div>

              <div class="row gy-3 mt-2">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Engine Distance</label>
                  <input type="number" class="form-control" formControlName="engineLogDistance"
                    (input)="calculateSlip()" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Engine Speed</label>
                  <input type="number" class="form-control" formControlName="engineSpeed" (input)="calculateSlip()" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel">Slip (%)</label>
                  <input type="number" class="form-control disabled-field" formControlName="slipPercentage" />
                </div>
              </div>

              <div class="row gy-3 mt-2">
                <div class="col-md-6">
                  <label class="TextLabel"><span class="asterik-color">*</span> Engine M/E Load %</label>
                  <input type="number" class="form-control" formControlName="engineLoadPercent" />
                </div>

                <div class="col-md-6">
                  <label class="TextLabel"><span class="asterik-color">*</span> M/E Running Hrs</label>
                  <input type="number" class="form-control" formControlName="meRunningHours" />
                </div>
              </div>
            </div>
          </div> -->
          <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">

            <!-- LEFT LABEL -->
            <div class="col-md-4">
              <label><span class="asterik-color">*</span>Engine Room Log:</label>
            </div>

            <!-- RIGHT CONTENT -->
            <div class="col-md-8 textBox">

              <!-- ⭐ At Sea Fields -->
              <div class="row gy-3 mb-2" *ngIf="isAtSea">

                <div class="col-md-3">
                  <label class="TextLabel">ER Temp (degC)</label>
                  <input type="number" class="form-control" formControlName="erTemp" step="0.01" inputmode="decimal"
                    min="0" (input)="validateDecimal('erTemp')" />
                </div>

                <div class="col-md-3">
                  <label class="TextLabel">Scavenge Air Press (bar)</label>
                  <input type="number" class="form-control" formControlName="scavengeAirPress" step="0.01"
                    inputmode="decimal" min="0" (input)="validateDecimal('scavengeAirPress')" />
                </div>

                <div class="col-md-3">
                  <label class="TextLabel">Scavenge Air Temp (degC)</label>
                  <input type="number" class="form-control" formControlName="scavengeAirTemp" step="0.01"
                    inputmode="decimal" min="0" (input)="validateDecimal('scavengeAirTemp')" />
                </div>

                <div class="col-md-3">
                  <label class="TextLabel">Air Cooler CW Inlet Temp (degC)</label>
                  <input type="number" class="form-control" formControlName="airCoolerTemp" step="0.01"
                    inputmode="decimal" min="0" (input)="validateDecimal('airCoolerTemp')" />
                </div>

              </div>

              <!-- Engine Main Fields -->
              <div class="row gy-3">

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Main Engine RPM</label>
                  <input type="number" class="form-control" formControlName="mainEngineRpm" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Engine Avg KW</label>
                  <input type="number" class="form-control" formControlName="engineAverageBhp" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Revolution Counter</label>
                  <input type="number" class="form-control" formControlName="meRevolutionCounter" />
                </div>

              </div>

              <div class="row gy-3 mt-2">

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Engine Distance</label>
                  <input type="number" class="form-control" formControlName="engineLogDistance"
                    (input)="calculateSlip()" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Engine Speed</label>
                  <input type="number" class="form-control" formControlName="engineSpeed" (input)="calculateSlip()" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel">Slip (%)</label>
                  <input type="number" class="form-control disabled-field" formControlName="slipPercentage" />
                </div>

              </div>

              <div class="row gy-3 mt-2">

                <div class="col-md-6">
                  <label class="TextLabel"><span class="asterik-color">*</span> Engine M/E Load %</label>
                  <input type="number" class="form-control" formControlName="engineLoadPercent" />
                </div>

                <div class="col-md-6">
                  <label class="TextLabel"><span class="asterik-color">*</span> M/E Running Hrs</label>
                  <input type="number" class="form-control" formControlName="meRunningHours" />
                </div>

              </div>

            </div>

          </div>
          <!-- ===================== BUNKER RECEIVED GRADE 1/2/3 ===================== -->
          <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
            <div class="col-md-4">
              <label class="invisible-title">.</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-4">
                  <label class="TextLabel">Bunker Received (Grade 1)</label>
                  <select class="form-control" formControlName="bunkerGrade1">
                    <option value="" disabled>Select Grade</option>
                    <option value="HSFO">HSFO</option>
                    <option value="VLSFO">VLSFO</option>
                    <option value="MGO">MGO</option>
                    <option value="LNG">LNG</option>
                    <option value="ULSFO">ULSFO</option>
                  </select>
                </div>

                <div class="col-md-4">
                  <label class="TextLabel">Quantity (MT)</label>
                  <input type="number" class="form-control" formControlName="quantity1" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel">Discrepency (MT)</label>
                  <input type="number" class="form-control" formControlName="descrepency1" />
                </div>
              </div>

              <div class="row gy-3 mt-2">
                <div class="col-md-4">
                  <label class="TextLabel">Bunker Received (Grade 2)</label>
                  <select class="form-control" formControlName="bunkerGrade2">
                    <option value="" disabled>Select Grade</option>
                    <option value="HSFO">HSFO</option>
                    <option value="VLSFO">VLSFO</option>
                    <option value="MGO">MGO</option>
                    <option value="LNG">LNG</option>
                    <option value="ULSFO">ULSFO</option>
                  </select>
                </div>

                <div class="col-md-4">
                  <label class="TextLabel">Quantity (MT)</label>
                  <input type="number" class="form-control" formControlName="quantity2" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel">Discrepency (MT)</label>
                  <input type="number" class="form-control" formControlName="descrepency2" />
                </div>
              </div>

              <div class="row gy-3 mt-2">
                <div class="col-md-4">
                  <label class="TextLabel">Bunker Received (Grade 3)</label>
                  <select class="form-control" formControlName="bunkerGrade3">
                    <option value="" disabled>Select Grade</option>
                    <option value="HSFO">HSFO</option>
                    <option value="VLSFO">VLSFO</option>
                    <option value="MGO">MGO</option>
                    <option value="LNG">LNG</option>
                    <option value="ULSFO">ULSFO</option>
                  </select>
                </div>

                <div class="col-md-4">
                  <label class="TextLabel">Quantity (MT)</label>
                  <input type="number" class="form-control" formControlName="quantity3" />
                </div>

                <div class="col-md-4">
                  <label class="TextLabel">Discrepency (MT)</label>
                  <input type="number" class="form-control" formControlName="descrepency3" />
                </div>
              </div>
            </div>
          </div>

          <!-- ===================== OLD ROB ===================== -->
          <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
            <div class="col-md-4">
              <label class="invisible-title">.</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-3">
                  <label class="TextLabel"><span class="asterik-color">*</span> HSFO Old ROB</label>
                  <input type="number" class="form-control" formControlName="mgoMeOldRob" />
                </div>

                <div class="col-md-3">
                  <label class="TextLabel"><span class="asterik-color">*</span> VLSFO Old ROB</label>
                  <input type="number" class="form-control" formControlName="mgoAeOldRob" />
                </div>

                <div class="col-md-3">
                  <label class="TextLabel"><span class="asterik-color">*</span> ULSFO Old ROB</label>
                  <input type="number" class="form-control" formControlName="mgoBlrOldRob" />
                </div>

                <div class="col-md-3">
                  <label class="TextLabel"><span class="asterik-color">*</span> MGO Total Old ROB</label>
                  <input type="number" class="form-control" formControlName="mgoTotalOldRob" />
                </div>
              </div>

              <div class="row gy-3 mt-2" *ngIf="requestForm.get('vesselType')?.value === 'Gas Carrier'">
                <div class="col-md-4">
                  <label class="TextLabel">LNG Total Old ROB</label>
                  <input type="number" class="form-control" formControlName="lngTotalOldRob" />
                </div>
              </div>
            </div>
          </div>
          <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
            <div class="col-md-4">
              <label><span class="asterik-color">*</span>Fuel Oil Consumption:</label>
            </div>

            <div class="col-md-8 textBox">
              <div formArrayName="fuelOilData">
                <div class="fuel-oil-block mb-3" *ngFor="let row of fuelOilData.controls; let i = index"
                  [formGroupName]="i">
                  <div class="row gy-3 align-items-end">
                    <div class="col-md-3">
                      <label class="TextLabel"><span class="asterik-color">*</span> Fuel Oil</label>

                      <div class="d-flex gap-2 align-items-center">
                        <select class="form-control" formControlName="fuelType">
                          <option value="" disabled>Select</option>
                          <option value="HSFO">HSFO</option>
                          <option value="VLSFO">VLSFO</option>
                          <option value="ULSFO">ULSFO</option>
                          <option value="LNG">LNG</option>
                          <option value="BIO FUEL">BIO FUEL</option>
                        </select>

                        <button type="button" class="btn btn-success btn-sm" (click)="addFuelOilRow()"
                          *ngIf="i === fuelOilData.length - 1">
                          +
                        </button>

                        <button type="button" class="btn btn-danger btn-sm" (click)="removeFuelOilRow(i)"
                          *ngIf="fuelOilData.length > 1">
                          −
                        </button>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <label class="TextLabel"><span class="asterik-color">*</span> M/E Consmp (MT)</label>
                      <input type="text" class="form-control" formControlName="meConsumption"
                        (input)="calculateFuelTotal(i)" />
                    </div>

                    <div class="col-md-3">
                      <label class="TextLabel"><span class="asterik-color">*</span> A/E Consmp (MT)</label>
                      <input type="text" class="form-control" formControlName="aeConsumption"
                        (input)="calculateFuelTotal(i)" />
                    </div>

                    <div class="col-md-3">
                      <label class="TextLabel">BLR Consmp (MT)</label>
                      <input type="text" class="form-control" formControlName="blrConsumption"
                        (input)="calculateFuelTotal(i)" />
                    </div>

                    <div class="col-md-3">
                      <label class="TextLabel">Others Type</label>
                      <select class="form-control" formControlName="othersType">
                        <option value="" disabled>Select</option>
                        <option value="Purging">Purging</option>
                        <option value="Heating">Heating</option>
                        <option value="Tank Cleaning">Tank Cleaning</option>
                      </select>
                    </div>

                    <div class="col-md-3">
                      <label class="TextLabel">Others Qty</label>
                      <input type="text" class="form-control" formControlName="othersQty"
                        (input)="calculateFuelTotal(i)" />
                    </div>

                    <div class="col-md-3">
                      <label class="TextLabel">Total Consumption (MT)</label>
                      <input type="text" class="form-control" formControlName="totalConsumption" readonly />
                    </div>

                    <div class="col-md-3">
                      <label class="TextLabel"><span class="asterik-color">*</span> Bunker ROB
                        Current</label>
                      <input type="text" class="form-control" formControlName="bunkerRob" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
            <div class="col-md-4">
              <label><span class="asterik-color">*</span>MGO/MDO Consumption:</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-3">
                  <label class="TextLabel"><span class="asterik-color">*</span> MGO M/E Consmp</label>
                  <input type="text" class="form-control" formControlName="mgoMeConsumption"
                    (input)="calculateMgoTotal()" />
                </div>

                <div class="col-md-3">
                  <label class="TextLabel"><span class="asterik-color">*</span> MGO A/E Consmp</label>
                  <input type="text" class="form-control" formControlName="mgoAeConsumption"
                    (input)="calculateMgoTotal()" />
                </div>

                <div class="col-md-3">
                  <label class="TextLabel"><span class="asterik-color">*</span> MGO BLR Consmp</label>
                  <input type="text" class="form-control" formControlName="mgoBlrConsumption"
                    (input)="calculateMgoTotal()" />
                </div>

                <div class="col-md-3">
                  <label class="TextLabel">MGO Others Type</label>
                  <select class="form-control" formControlName="mgoOthersConsumptionType">
                    <option value="" disabled>Select</option>
                    <option value="Purging">Purging</option>
                    <option value="Heating">Heating</option>
                    <option value="Tank Cleaning">Tank Cleaning</option>
                  </select>
                </div>

                <div class="col-md-3">
                  <label class="TextLabel">MGO Others Qty</label>
                  <input type="text" class="form-control" formControlName="mgoOthersConsumptionQuantity"
                    (input)="calculateMgoTotal()" />
                </div>

                <div class="col-md-3">
                  <label class="TextLabel">Gas Oil Power Pack</label>
                  <input type="text" class="form-control" formControlName="gasOilPowerPack"
                    (input)="calculateMgoTotal()" />
                </div>

                <div class="col-md-3">
                  <label class="TextLabel">Incinerator Gas Oil</label>
                  <input type="text" class="form-control" formControlName="incineratorGasOil"
                    (input)="calculateMgoTotal()" />
                </div>

                <div class="col-md-3">
                  <label class="TextLabel">Inerting Gas Oil</label>
                  <input type="text" class="form-control" formControlName="inertingGasOil"
                    (input)="calculateMgoTotal()" />
                </div>

                <div class="col-md-3">
                  <label class="TextLabel">MGO Total Consumption</label>
                  <input type="text" class="form-control" formControlName="mgoTotalConsumption" readonly />
                </div>

                <div class="col-md-3">
                  <label class="TextLabel"><span class="asterik-color">*</span> MGO ROB Current</label>
                  <input type="text" class="form-control" formControlName="mgoBunkerRob" />
                </div>
              </div>
            </div>
          </div>

          <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
            <div class="col-md-4">
              <label>Auxiliary Engines:</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3">
                <div class="col-md-6">
                  <label class="TextLabel">Auxiliary Engine 1 - Hours</label>
                  <input type="number" class="form-control" formControlName="auxEngineOneHours" />
                </div>

                <div class="col-md-6">
                  <label class="TextLabel">Auxiliary Engine 1 - Power (KW)</label>
                  <input type="number" class="form-control" formControlName="auxEngineOneKw" />
                </div>
              </div>

              <div class="row gy-3 mt-2">
                <div class="col-md-6">
                  <label class="TextLabel">Auxiliary Engine 2 - Hours</label>
                  <input type="number" class="form-control" formControlName="auxEngineTwoHours" />
                </div>

                <div class="col-md-6">
                  <label class="TextLabel">Auxiliary Engine 2 - Power (KW)</label>
                  <input type="number" class="form-control" formControlName="auxEngineTwoKw" />
                </div>
              </div>

              <div class="row gy-3 mt-2">
                <div class="col-md-6">
                  <label class="TextLabel">Auxiliary Engine 3 - Hours</label>
                  <input type="number" class="form-control" formControlName="auxEngineThreeHours" />
                </div>

                <div class="col-md-6">
                  <label class="TextLabel">Auxiliary Engine 3 - Power (KW)</label>
                  <input type="number" class="form-control" formControlName="auxEngineThreeKw" />
                </div>
              </div>
            </div>
          </div>

          <div class="row gy-3 mt-2"
            *ngIf="requestForm.get('vesselType')?.value === 'Oil Tanker' || requestForm.get('vesselType')?.value === 'Chemical Tanker'">
            <div class="col-md-3">
              <label class="TextLabel">COP 1 Avg RPM</label>
              <input type="number" class="form-control" formControlName="copOneRpm" />
            </div>
            <div class="col-md-3">
              <label class="TextLabel">COP 2 Avg RPM</label>
              <input type="number" class="form-control" formControlName="copTwoRpm" />
            </div>
            <div class="col-md-3">
              <label class="TextLabel">COP 3 Avg RPM</label>
              <input type="number" class="form-control" formControlName="copThreeRpm" />
            </div>
            <div class="col-md-3">
              <label class="TextLabel">Hydraulic Sys Avg Press (bar)</label>
              <input type="number" class="form-control" formControlName="hydraulicSysPressure" />
            </div>
          </div>


          <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
            <div class="col-md-4">
              <label><span class="asterik-color">*</span>Miscellaneous:</label>
            </div>

            <div class="col-md-8 textBox">
              <div class="row gy-3 align-items-end">
                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Freshwater Quantity
                    (MT)</label>
                  <input type="number" class="form-control" formControlName="freshWaterRob" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('freshWaterRob')?.hasError('required'),
                }" />
                  <small class="error" *ngIf="
                  formSubmitted &&
                  requestForm.get('freshWaterRob')?.hasError('required')
                ">
                    Freshwater quantity is required.
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="TextLabel"><span class="asterik-color">*</span> Distilled Water Quantity
                    (MT)</label>
                  <input type="number" class="form-control" formControlName="distilledWaterQty" [ngClass]="{
                  'error-border':
                    formSubmitted &&
                    requestForm.get('distilledWaterQty')?.hasError('required'),
                }" />
                  <small class="error" *ngIf="
                  formSubmitted &&
                  requestForm.get('distilledWaterQty')?.hasError('required')
                ">
                    Distilled Water quantity is required.
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="TextLabel">Remarks</label>
                  <input type="text" class="form-control" formControlName="voyageRemarks" />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- <div class="text-right">
    <button class="btn btn-light hover-button mail" (click)="topClick()">
      <mat-icon>arrow_upward</mat-icon> &nbsp;Go top
    </button>
    <button class="btn btn-light hover-button mail" (click)="clearClick()">
      <mat-icon>clear_all</mat-icon> &nbsp;Clear
    </button>
    <button class="btn btn-light hover-button mail" (click)="submitClick()">
      <mat-icon>done</mat-icon> Submit
    </button>
  </div> -->
      <button class="table-fab" (click)="openVoyageDrawer()" matTooltip="Voyage Data">
        <mat-icon>table_view</mat-icon>
      </button>
      <br />
    </div>
  </mat-drawer-content>
  <mat-drawer #voyageDrawer mode="over" position="end" class="drawer-panel">
    <div class="drawer-shell">

      <!-- HEADER -->
      <div class="drawer-header">
        <div class="drawer-title">
          <div class="drawer-main-title">Voyage Summary</div>
          <div class="drawer-subtitle">Last 4 Reports Snapshot</div>
        </div>

        <button class="drawer-close-btn" (click)="voyageDrawer.close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- TABLE AREA -->
      <div class="drawer-table-scroll">


        <div *ngIf="isVoyageLoading" class="drawer-loader">
          Loading voyage data...
        </div>


        <div *ngIf="!isVoyageLoading && !voyageHeaders.length" class="drawer-empty">
          No voyage data available
        </div>


        <table class="voyage-table-dark" *ngIf="voyageHeaders.length">

          <thead>
            <tr>
              <th style="width:40%">Field</th>
              <th style="width:20%" *ngFor="let row of voyageRows; let i = index">
                Vessel Report{{ i + 1 }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let header of voyageHeaders">
              <td class="field">{{ header.label }}</td>

              <td *ngFor="let row of voyageRows">
                <ng-container [ngSwitch]="header.key">


                  <span *ngSwitchCase="'Date'">
                    {{ row[header.key] | date:'yyyy-MM-dd' }}
                  </span>


                  <span *ngSwitchCase="'Time'">
                    {{ row[header.key] || '-' }}
                  </span>


                  <span *ngSwitchDefault>
                    {{ row[header.key] ?? '-' }}
                  </span>

                </ng-container>
              </td>
            </tr>
          </tbody>

        </table>
      </div>
    </div>
  </mat-drawer>


</mat-drawer-container>